import request from '@/utils/request'

export function getMemberTagLimit() {
  return request({
    url: '/api/Extend/LqMemberTag/Actions/GetLimit',
    method: 'get'
  })
}

export function searchMemberTags(data) {
  return request({
    url: '/api/Extend/LqMemberTag/Actions/Search',
    method: 'get',
    data
  })
}

export function bindMemberTag(memberId, data) {
  return request({
    url: `/api/Extend/LqMemberTag/Member/${memberId}/Tags`,
    method: 'post',
    data
  })
}

export function unbindMemberTag(memberId, tagId) {
  return request({
    url: `/api/Extend/LqMemberTag/Member/${memberId}/Tags/${tagId}`,
    method: 'delete'
  })
}
